import { InputLabel, MenuItem, Stack, TextField } from "@mui/material";

export const InputTextField = (props) => {
  return (
    <Stack spacing={1} sx={{ height: "100%", width: "100%", ...props?.sx }}>
      <InputLabel
        sx={{
          fontFamily: "Basier Circle",
          fontSize: "18px",
          color: "#091B3D",
          lineHeight: "22px",
          marginBottom: "8px !important",
        }}
        required={props?.required}
      >
        {props?.label}
      </InputLabel>

      <div
        style={{
          margin: "auto 0 0 0",
          width: "100%",
        }}
      >
        <TextField
          {...props}
          label=""
          select={props?.type === "list"}
          name={props?.name}
          autoComplete="off"
          id={props?.name}
          variant="outlined"
          required={props?.required}
          error={props?.errorValue}
          value={props?.value}
          onChange={props?.onChange}
          type={props?.type}
          helperText={props?.errorValue ? props?.helperText : null}
          sx={{
            "& .MuiInputBase-root.MuiOutlinedInput-root": {
              height: props?.heightTextField ? props?.heightTextField : "45px",
              textAlign: "left",
              borderRadius: props?.borderRadius ? props?.borderRadius : "4px",

              ...(props?.highliteInput && { backgroundColor: "#feffe8" }),
            },
            "& .MuiInputBase-input.MuiOutlinedInput-input": {
              padding: "12px 14px",

              // ...(props?.highliteInput && { backgroundColor: "red" }),
            },
            "& .MuiInputBase-root.MuiOutlinedInput-root.MuiOutlinedInput-root":
              {
                fieldset: {
                  border: "1px solid  #8f8f8f",
                },
              },
            width: "100%",
          }}
          disabled={props?.disabled}
        >
          {props?.type === "list" &&
            props?.options?.map((option) => (
              <MenuItem key={option?.value} value={option?.value}>
                {option?.label}
              </MenuItem>
            ))}
        </TextField>
      </div>
    </Stack>
  );
};

export default InputTextField;
